import axios from 'axios'


export const sendMessage = (message) => {
  const url = `https://hooks.slack.com/services/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`
  const options = {
    text: message,
  }

  axios.post(url, JSON.stringify(options))
    .then((response) => {
      console.log('SUCCEEDED: Sent slack webhook: \n', response)
    })
    .catch((error) => {
      console.log('FAILED: Send slack webhook', error)
    })
}